import { AccessGrantState } from '../../../__generated__/graphql';
import { QuickActionCTAType } from '../@types/QuickActionBarTypes';

type ActionState = {
  [key in QuickActionCTAType]: boolean;
};

const actionStates: Record<AccessGrantState, ActionState> = {
  PRE_CHECK_IN: {
    checkIn: true,
    checkOut: false,
    blockCheckIn: true,
    getAutenticationCredentials: true,
    remotePrintKeyCard: true,
    repollReservation: true,
    error: false,
    other: false,
  },
  IN_HOUSE: {
    checkIn: false,
    checkOut: true,
    blockCheckIn: false,
    getAutenticationCredentials: true,
    remotePrintKeyCard: true,
    repollReservation: true,
    error: false,
    other: false,
  },
  CHECKED_OUT: {
    checkIn: false,
    checkOut: false,
    blockCheckIn: false,
    getAutenticationCredentials: true,
    remotePrintKeyCard: true,
    repollReservation: true,
    error: false,
    other: false,
  },
  CANCELED: {
    checkIn: false,
    checkOut: false,
    blockCheckIn: false,
    getAutenticationCredentials: false,
    remotePrintKeyCard: false,
    repollReservation: false,
    error: false,
    other: false,
  },
};

export const getActionButtonState = (
  ctaType: QuickActionCTAType,
  agState: AccessGrantState
): boolean => {
  return actionStates[agState][ctaType];
};
